import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import {
  createSpaceInProjectTemplate,
  CreateSpaceInProjectTemplatePayload,
} from '../../actions';
import { createProjectTemplateSpace } from '../../slices';

function* createSpaceInTemplateSaga(
  action: StoreActionProps<CreateSpaceInProjectTemplatePayload>,
) {
  try {
    const { payload } = action;

    const spaceId = floatUid();

    const space = {
      ...payload.space,
      spaceId,
    };

    yield put(createProjectTemplateSpace(space));
  } catch (error) {
    logger.error('createProjectTemplateSpace failed', { error });

    message.error('There was an error creating a space in the template');
  }
}

export function* watchCreateSpaceInProjectTemplateSaga(): Generator {
  yield takeLatest(
    createSpaceInProjectTemplate.type,
    createSpaceInTemplateSaga,
  );
}
